(function () {
  'use strict';
  // Handles variant CHANGES only.
  // The initial variant max is already set by the inline script in theme.liquid.
  var apply = (window.__invLimiter || {}).apply || function () {};
  var cache = {};

  function fetchMax(id, cb) {
    if (id in cache) { cb(cache[id]); return; }
    fetch('/variants/' + id + '.js')
      .then(function (r) { return r.json(); })
      .then(function (v) {
        var max = (v.inventory_management === 'shopify' && v.inventory_policy === 'deny')
          ? v.inventory_quantity : null;
        cache[id] = max;
        cb(max);
      })
      .catch(function () { cache[id] = null; cb(null); });
  }

  function variantId() {
    var p = new URLSearchParams(window.location.search).get('variant');
    if (p) return p;
    var sels = ['product-form input[name="id"]', '.product-variant-id', 'form[action*="/cart/add"] input[name="id"]'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el && el.value) return el.value;
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var last = variantId();
    new MutationObserver(function () {
      var cur = variantId();
      if (cur && cur !== last) { last = cur; fetchMax(cur, apply); }
    }).observe(
      document.querySelector('product-info') || document.querySelector('.product') || document.body,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] }
    );
  });
})();
